export enum FeaturesCode {
    Tasks = "Tasks",
    TaskTypes ="TaskTypes",
    Users="Users",
    Customization="Customization",
    Workflows="Workflows",
    ProcessInstances="ProcessInstances",
    FieldPermissions="FieldPermissions",
    FeaturePermissions = "FeaturePermissions",
    AuditLogs = "AuditLogs"
}